import { Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./styles/app.sass";
import Page from "./components/Page";
import Home from "./screens/Home";
import Pricing from "./screens/Pricing";
import Actualites from "./screens/Actualites";
import Article from "./screens/Article";
import Apprentissage from "./screens/Apprentissage";
import Emargement from "./screens/Emargement";
import Contact from "./screens/Contact";
import Opco from "./screens/Opco";
import Prospection from "./screens/Prospection";
import Rapports from "./screens/Rapports";
import GestionDocuments from "./screens/GestionDocuments";
import Conditions from "./screens/Conditions";
import Confidentialite from "./screens/Confidentialite";
import Page404 from "./screens/Page404";
import ArticleRedirect from "./components/ArticleRedirect";


function App() {
    return (
        <HelmetProvider>
            <Routes>
            <Route path="/">
                <Route
                    index
                    element={
                        <Page>
                            <Home />
                        </Page>
                    }
                />
                <Route
                    path="forfaits"
                    element={
                        <Page>
                            <Pricing />
                        </Page>
                    }
                />
                <Route
                    path="opco"
                    element={
                        <Page>
                            <Opco />
                        </Page>
                    }
                />
                <Route
                    path="actualites"
                    element={
                        <Page>
                            <Actualites />
                        </Page>
                    }
                />
                {/* Route principale avec slug SEO-friendly */}
                <Route
                    path="article/:slug"
                    element={
                        <Page>
                            <Article />
                        </Page>
                    }
                />
                {/* Route de redirection SEO pour les anciens liens avec ID */}
                <Route
                    path="article/id/:id"
                    element={<ArticleRedirect />}
                />
                <Route
                    path="contrat-apprentissage"
                    element={
                        <Page>
                            <Apprentissage />
                        </Page>
                    }
                />
                <Route
                    path="emargement-assiduite"
                    element={
                        <Page>
                            <Emargement />
                        </Page>
                    }
                />
                <Route
                    path="contact"
                    element={
                        <Page>
                            <Contact />
                        </Page>
                    }
                />
                <Route
                    path="prospection-leads"
                    element={
                        <Page>
                            <Prospection />
                        </Page>
                    }
                />
                <Route
                    path="rapports-statistiques"
                    element={
                        <Page>
                            <Rapports />
                        </Page>
                    }
                />
                <Route
                    path="gestion-documents"
                    element={
                        <Page>
                            <GestionDocuments />
                        </Page>
                    }
                />

                <Route
                    path="cgu"
                    element={
                        <Page>
                            <Conditions />
                        </Page>
                    }
                />

                <Route
                    path="confidentialite"
                    element={
                        <Page>
                            <Confidentialite />
                        </Page>
                    }
                />

                {/* Redirections 301 pour anciennes URLs (Soft 404) */}
                <Route path="download" element={<Navigate to="/contact" replace />} />
                <Route path="features" element={<Navigate to="/" replace />} />
                <Route path="features/dashboard" element={<Navigate to="/" replace />} />
                <Route path="features/emargement" element={<Navigate to="/emargement-assiduite" replace />} />
                <Route path="features/billing" element={<Navigate to="/forfaits" replace />} />
                <Route path="features/signature" element={<Navigate to="/emargement-assiduite" replace />} />
                <Route path="features/opco" element={<Navigate to="/opco" replace />} />
                <Route path="emargement" element={<Navigate to="/emargement-assiduite" replace />} />

                {/* Route 404 explicite pour les redirections */}
                <Route
                    path="404"
                    element={<Page404 />}
                />
                
                {/* Route 404 - doit être en dernier */}
                <Route
                    path="*"
                    element={<Page404 />}
                />
    
            </Route>
        </Routes>
        </HelmetProvider>
    );
}

export default App;

